import styled from "styled-components";

export const ModalWrapper = styled.div`
  position: fixed;
  z-index: 9999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.8);
`;

export const ModalContainer = styled.div`
  position: relative;
  background: ${({ theme }) => theme.colors.white};
  margin: 15% auto;
  padding: 30px;
  border: 1px solid #888;
  width: 86%;
  max-width: 620px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  .buttons-wrapper {
    display: flex;
    justify-content: space-between;
    margin-top: 40px;
  }
  .text {
    max-width: 527px;
    font-family: Inter;
    font-size: 20px;
    font-weight: 400;
    line-height: 36px;
    &-warning {
      font-family: JetBrains Mono;
      font-size: 29px;
      font-weight: 700;
    }
  }

  @media (min-width: 1024px) {
    padding: 49px 30px 30px;
    max-width: 586px;
  }
`;
export const Close = styled.span`
  position: absolute;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.dark};
  text-align: center;
  vertical-align: center;
  line-height: 22px;
  top: 15px;
  right: 30px;
  color: ${({ theme }) => theme.colors.white};
  font-size: 20px;
  font-weight: 100;
  transition: 0.3s;
  cursor: pointer;
  &:hover,
  &:focus {
    opacity: 0.7;
  }
  @media (min-width: 1024px) {
    top: 30px;
  }
`;
